<style lang="scss" scoped>
  .nav {
    position: absolute;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 106px;
    .logo {
      float: left;
      margin-left: 22%;
      margin-top: 6px;
      padding-left: 4px;
    }
    .menus {
      float: left;
      margin-left: 9%;
    }
    .menu-item {
      float: left;
      color: #ffffff;
      font-size: 21px;
      line-height: 76px;
      cursor: pointer;
      letter-spacing: 2px;
      margin-right: 50px;
      &:hover {
        color: #952b4f;
      }
    }
    .menu-item-choose {
      color: #952b4f;
    }
  }
  .index-lantern {
    position: absolute;
    z-index: 100;
    top: 82px;
    right: 15%;
    width: 139px;
    height: 239px;
    background: url('../assets/pc/index-lantern.png');
    cursor: pointer;
    color: #904b60  ;
    text-align: center;
    writing-mode: vertical-lr;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 6px;
    .index-lantern-light {
      position: absolute;
      animation:animation1 5s linear infinite;
    }
  }
  .index-lantern-animate {
    animation:animation2 10s linear infinite;
    transform-origin:50% 0%;
  }
  @keyframes animation1 {
		0%{ opacity: 1; }
    5%{ opacity: 1; }
		25%{ opacity: 0.8; }
    35%{ opacity: 0.5; }
    40%{ opacity: 0.3; }
    45%{ opacity: 0; }
    55%{ opacity: 0; }
		61%{ opacity: 0.5; }
    75%{ opacity: 0.8; }
    95%{ opacity: 1; }
		100%{ opacity: 1; }
	}
  @keyframes animation2 {
		0%{ transform: rotate(0deg); }
    10%{ transform: rotate(15deg); }
    25%{ transform: rotate(30deg); }
    40%{ transform: rotate(15deg); }
    50%{ transform: rotate(0deg); }
    60%{ transform: rotate(-15deg); }
    75%{ transform: rotate(-30deg); }
    90%{ transform: rotate(-15deg); }
    100%{ transform: rotate(0deg); }
	}
</style>

<template>
  <div class="home">
    <div :style="{'background': 'url('+ navBg +')'}" class="nav">
      <img class="logo" :src="logo" alt="logo" style="width: 96px; height: 98px;">
      <div class="menus">
        <div
          v-for="item in menuList"
          :key="item.id"
          @click="goPage(item.id, item.path)"
          :class="{'menu-item-choose': item.id===menuChoose}"
          class="menu-item"
        >
          {{item.name}}
        </div>
      </div>
    </div>
    <div
      class="index-lantern" v-show="lanternShow=='1'"
      :class="{'index-lantern-animate':indexLanternAnimate}"
      @mouseover="indexLanternAnimate=false"
      @mouseout="indexLanternAnimate=true"
      @click="goLink"
    >
      <img class="index-lantern-light" src="../assets/pc/index-lantern-light.png" alt="">
      {{lanternword}}
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      menuList: [
        { name: '首页', id: '1', path: 'p-index' },
        { name: '世界见闻', id: '2', path: 'p-experience' },
        { name: '羁绊主角', id: '3', path: 'p-role' },
        { name: '世界特色', id: '4', path: 'p-characteristic' },
        { name: '声色印象', id: '5', path: 'p-impression' },
        { name: '世界观', id: '6', path: 'p-viewpoint' }
      ],
      menuChoose: '1',
      navBg: '',
      indexLanternAnimate: true,
      lanternShow: '1',
      lanternword: '',
			lanternLink: '',
      logo:'',
    }
  },
  mounted() {
    // const width = document.body.clientWidth;
    // if(width < 850) {
    //   this.$router.push({name: 'm-index'});
    // } else {

    // }
    this.init();
  },
  methods: {
    init() {
      this.$http.get('/api/website/getGeneralInfo?platform=1').then((rsp) => {
        // 导航背景
        this.navBg = rsp.result.navigationFilePath.filePath;
        // 预约
        this.indexLanternAnimate = rsp.result.indexSuspend.wasShow == '1' ? true : false;
        this.lanternShow = rsp.result.indexSuspend.wasShow
        this.lanternword = rsp.result.indexSuspend.isValue;
        this.lanternLink = rsp.result.indexSuspend.isUrl;
        this.logo = rsp.result.navigationLogo.filePath;
      });
    },
    goPage(id, path) {
      this.menuChoose = id;
      this.$router.push({name: path});
    },
    goLink() {
      window.open(this.lanternLink, '_blank');
		}
  }
}
</script>
